import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { ConfirmDialogComponent, DEFAULT_SNACKBAR_CONFIG, Logger } from 'src/app/@shared';
import { Filter } from 'src/app/@shared/models/filter.model';
import { CloneEventComponent, Event, EventService, Offer, OfferDomain, OfferPromoSortDialogComponent, OfferService, OfferTag, OfferTagService, Version, VersionService } from '../..';
import { OfferPromo } from 'src/app/modules/standard/v1';
import { PromoDomain } from 'src/app/modules/standard/v1';
import { OfferPromoService } from 'src/app/modules/standard/v1';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Status } from '../../models/offer-promo-status';
import { StatusCount } from '../../models/status-count.model';

const log = new Logger('OffersComponent');

@Component({
  selector: 'app-version-offers',
  templateUrl: './version-offers.component.html',
  styleUrls: ['./version-offers.component.scss']
})

export class VersionOffersComponent
<TEvent extends Event, Tag extends OfferTag, TOfferPromo extends OfferPromo, T extends Offer,
TOfferDomain extends OfferDomain<Offer>, TPromoDomain extends PromoDomain<OfferPromo>> implements OnInit {

  public offerpromos = [
    { name: 'Offers', value: 'OFFER' },
    { name: 'Promos', value: 'PROMO' }
  ];

  public statusCount: StatusCount = {};
  @ViewChild(MatSidenav) sidenav!: MatSidenav;
  @ViewChild('offerPromoTable', { static: false }) offerPromoTable: any;
  @ViewChild('offerPromoCards', { static: false }) offerPromoCards: any;
  viewModel$ = combineLatest([
    this.eventService.getEvent(this.route.snapshot.params['eventId']),
    this.offerpromoService.isLoading$,
    this.offerpromoService.viewMode$,
    this.offerpromoService.eventId$,
    this.offerTagService.OfferTagsList$
  ]).pipe(
    map(([event, isLoading, viewMode, eventId,  offerTags]) => {
      return { event, isLoading, viewMode, eventId, offerTags }
    }),
  );

  filtersForm = new FormGroup({
    search: new FormControl(),
    versions: new FormControl(),
    offerTags: new FormControl(),
    offerPromos: new FormControl()
  });


  constructor(
    private eventService: EventService<TEvent>,
    private offerpromoService: OfferPromoService<TOfferPromo, TPromoDomain>,
    private versionService: VersionService<Version>,
    private offerTagService: OfferTagService<Tag>,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private matSnackBar: MatSnackBar,
    public offerService: OfferService<T, TOfferDomain>,
  ) { }

  ngOnInit(): void {
    log.debug('init');
    this.offerService.offerId = this.route.snapshot.params['offerId'];
    this.offerpromoService.offerId = this.route.snapshot.params['offerId'];
    //this.offerpromoService.page({ pageIndex: 0, pageSize: 10 });
    this.clearSearch();
    this.clearFilters();
    // this.offerpromoService.statusUpdated$.subscribe(res => {
    //   this.getStatusCount();
    // })
    // this.offerpromoService.sort(this.offerSorting[0].id);
  }

  backOffers(){
    this.router.navigate([`../../`], { relativeTo: this.route, queryParamsHandling: 'preserve' });
  }


  getStatusCount() {
    this.offerpromoService.getStatusCount().subscribe((count) => {
      this.statusCount = count;
    })
  }

  onSearch(event: any) {
    this.offerpromoService.search(event.target.value);
  }

  onSort() {
    const dialogRef = this.dialog.open(OfferPromoSortDialogComponent);
  }
  clearSearch() {
    this.filtersForm.controls.search.setValue('');
    this.offerpromoService.search('');
  }

  toggleView(mode: string) {
    this.offerpromoService.toggleViewMode(mode);
  }

  clearFilters() {
    this.filtersForm.reset();
    this.offerpromoService.clearFilters();
  }

  removeFilter(filter: Filter) {
    if (filter.fieldName === 'versionId') {
      ///TODO: fix below
      this.filtersForm.patchValue({
        versions: this.filtersForm.controls.versions.value.filter((item: Version) => item.Id !== filter.value)
      });
    }
    this.offerpromoService.removeFilter(filter);
  }


  deleteSelectedRecords() {
    let selectedRecordsDetails: any;
    if (this.offerPromoTable) {
      selectedRecordsDetails = this.offerPromoTable.getSelectedSectionRecords();
    } else if (this.offerPromoCards) {
      selectedRecordsDetails = this.offerPromoCards.getSelectedSectionRecords();
    }
    if (selectedRecordsDetails && selectedRecordsDetails.length > 0) {

      const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Confirm Delete',
          message: `Do you want to remove selected Offer/Promo?`,
        },
        disableClose: true,
      });
      confirmDialog.afterClosed().subscribe(
        confirmResult => {
          if (confirmResult) {
            const selectedRecords = selectedRecordsDetails.map((x: any) => { x.EventId = this.route.snapshot.params['eventId']; return x.Detail; })
            this.offerpromoService.deleteOfferPromos(selectedRecords).subscribe({
              next: () => {
                this.matSnackBar.open(`Offer(s) deleted`, 'OK', DEFAULT_SNACKBAR_CONFIG);
                this.offerService.reload();
                this.offerpromoService.reload();
                if (this.offerPromoTable) {
                  this.offerPromoTable.clearSelection();
                } else if (this.offerPromoCards) {
                  this.offerPromoCards.clearSelection();
                }
              },
              error: (error) => {
                log.error('Error in deleting Offer/Promo', error);

                if (error.error.value) {
                  throw new Error(error.error.value);
                } else {
                  throw new Error(error.message);
                }
              }
            });
          }
        });
    }
  }



  updateStatus(status: Status) {
    let selectedRecordsDetails: any;
    if (this.offerPromoTable) {
      selectedRecordsDetails = JSON.parse(JSON.stringify(this.offerPromoTable.getSelectedSectionRecords()));
    } else if (this.offerPromoCards) {
      selectedRecordsDetails = JSON.parse(JSON.stringify(this.offerPromoCards.getSelectedSectionRecords()));
    }
    if (selectedRecordsDetails && selectedRecordsDetails.length > 0) {
      selectedRecordsDetails = selectedRecordsDetails.map((x: any) => { x.Detail.Status = status; return x.Detail; });
      this.offerpromoService.updateStatus(selectedRecordsDetails).subscribe({
        next: () => {
          this.offerService.reload();
          this.offerpromoService.reload();
          if (this.offerPromoTable) {
            this.offerPromoTable.clearSelection();
          } else if (this.offerPromoCards) {
            this.offerPromoCards.clearSelection();
          }
          this.getStatusCount();
        }
      })
    }
  }


}
